import { InputType } from 'storybook/internal/csf'

export enum STORYBOOK_TEXT_TYPE_ENUM {
  Empty = '',
  ShortTitle = 'Short title',
  LongTitle = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enim ad minim veniam. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enim ad minim veniam',
}

export const STORYBOOK_TEXTS = Object.values(STORYBOOK_TEXT_TYPE_ENUM)

export type StorybookTextType = (typeof STORYBOOK_TEXTS)[number]

export const STORYBOOK_TEXT_ARG_TYPE: InputType = {
  control: { type: 'select' },
  options: STORYBOOK_TEXTS,
}
